/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * Every period in scope, cell by cell.
 */
export const MaintenanceVisitPeriodsListQueryParams = zod.object({
  "car": zod.string().uuid().optional().describe('One elevator.'),
  "car_limit": zod.number().optional().describe('Return at most this many elevators. Defaults to all of them.'),
  "car_offset": zod.number().optional().describe('Skip this many elevators, in name order.'),
  "contract": zod.string().uuid().optional().describe('Every elevator on one contract, across its properties.'),
  "end_date": zod.string().date().optional().describe('Defaults to the last day of the current month.'),
  "property": zod.string().uuid().optional().describe('Every elevator at one property.'),
  "start_date": zod.string().date().optional().describe('Defaults to the first of the month eleven months back.')
})

export const MaintenanceVisitPeriodsListResponseItem = zod.object({
  "id": zod.string(),
  "carId": zod.string().uuid(),
  "carName": zod.string(),
  "propertyId": zod.string().uuid().nullable(),
  "propertyName": zod.string(),
  "serviceProviderName": zod.string(),
  "periodStart": zod.string().date(),
  "periodEnd": zod.string().date(),
  "periodMonths": zod.number(),
  "requiredQuantity": zod.number(),
  "requiredUnit": zod.enum(['visits', 'hours']).describe('\* `visits` - Visits\n\* `hours` - Hours'),
  "achievedQuantity": zod.number(),
  "hoursDerived": zod.boolean().describe('Every ticket behind this figure had its hours inferred from start and finish because no on-site time was reported, so the total can include travel and breaks. A period with a mix is not flagged here; the tickets carry it individually. Never true for a contract measured in visits.'),
  "coverage": zod.enum(['complete', 'partial', 'none']).describe('\* `complete` - Requirement met\n\* `partial` - Short of the requirement\n\* `none` - No records'),
  "resolution": zod.enum(['unresolved', 'not_performed']).describe('\* `unresolved` - Nobody has said\n\* `not_performed` - The rest never happened'),
  "isOpen": zod.boolean(),
  "clippedStart": zod.boolean(),
  "clippedEnd": zod.boolean(),
  "outcome": zod.enum(['done', 'partial', 'missing', 'skipped', 'open']).describe('\* `done` - Requirement met\n\* `partial` - Part of the work reached us\n\* `missing` - No record reached us\n\* `skipped` - Skipped visit\n\* `open` - Period still running'),
  "contested": zod.boolean(),
  "tickets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string(),
  "visitedOn": zod.string().date(),
  "hours": zod.number(),
  "hoursDerived": zod.boolean().describe('This ticket reported no on-site time, so its hours are the gap between start and finish.')
}).strict().describe('A maintenance ticket we hold for the period, enough to name it and link to it.')),
  "history": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.enum(['marked_not_performed', 'removed_not_performed', 'record_received']).describe('\* `marked_not_performed` - Marked as not performed\n\* `removed_not_performed` - Not performed removed\n\* `record_received` - Maintenance record received'),
  "at": zod.string().datetime({"offset":true}),
  "actor": zod.string(),
  "note": zod.string()
}).strict().describe('One entry in a period\'s timeline.'))
}).strict().describe('One cadence period on one elevator, as `build_visit_periods` derives it.')
export const MaintenanceVisitPeriodsListResponse = zod.array(MaintenanceVisitPeriodsListResponseItem)

/**
 * Take back a not-performed mark, leaving the period as the records find it.
 */
export const maintenanceVisitPeriodsClearNotPerformedCreateBodyNoteDefault = ``;

export const MaintenanceVisitPeriodsClearNotPerformedCreateBody = zod.object({
  "carId": zod.string().uuid(),
  "periodStart": zod.string().date(),
  "note": zod.string().default(maintenanceVisitPeriodsClearNotPerformedCreateBodyNoteDefault)
}).describe('Which period a write applies to. The pair is the period\'s identity.')

export const MaintenanceVisitPeriodsClearNotPerformedCreateResponse = zod.object({
  "id": zod.string(),
  "carId": zod.string().uuid(),
  "carName": zod.string(),
  "propertyId": zod.string().uuid().nullable(),
  "propertyName": zod.string(),
  "serviceProviderName": zod.string(),
  "periodStart": zod.string().date(),
  "periodEnd": zod.string().date(),
  "periodMonths": zod.number(),
  "requiredQuantity": zod.number(),
  "requiredUnit": zod.enum(['visits', 'hours']).describe('\* `visits` - Visits\n\* `hours` - Hours'),
  "achievedQuantity": zod.number(),
  "hoursDerived": zod.boolean().describe('Every ticket behind this figure had its hours inferred from start and finish because no on-site time was reported, so the total can include travel and breaks. A period with a mix is not flagged here; the tickets carry it individually. Never true for a contract measured in visits.'),
  "coverage": zod.enum(['complete', 'partial', 'none']).describe('\* `complete` - Requirement met\n\* `partial` - Short of the requirement\n\* `none` - No records'),
  "resolution": zod.enum(['unresolved', 'not_performed']).describe('\* `unresolved` - Nobody has said\n\* `not_performed` - The rest never happened'),
  "isOpen": zod.boolean(),
  "clippedStart": zod.boolean(),
  "clippedEnd": zod.boolean(),
  "outcome": zod.enum(['done', 'partial', 'missing', 'skipped', 'open']).describe('\* `done` - Requirement met\n\* `partial` - Part of the work reached us\n\* `missing` - No record reached us\n\* `skipped` - Skipped visit\n\* `open` - Period still running'),
  "contested": zod.boolean(),
  "tickets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string(),
  "visitedOn": zod.string().date(),
  "hours": zod.number(),
  "hoursDerived": zod.boolean().describe('This ticket reported no on-site time, so its hours are the gap between start and finish.')
}).strict().describe('A maintenance ticket we hold for the period, enough to name it and link to it.')),
  "history": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.enum(['marked_not_performed', 'removed_not_performed', 'record_received']).describe('\* `marked_not_performed` - Marked as not performed\n\* `removed_not_performed` - Not performed removed\n\* `record_received` - Maintenance record received'),
  "at": zod.string().datetime({"offset":true}),
  "actor": zod.string(),
  "note": zod.string()
}).strict().describe('One entry in a period\'s timeline.'))
}).strict().describe('One cadence period on one elevator, as `build_visit_periods` derives it.')

/**
 * Record that the scheduled maintenance did not happen.
 *
 * Only where nothing reached us. A period we hold part of the work for is a
 * shortfall to finish, and one still running cannot be answered for yet.
 */
export const maintenanceVisitPeriodsMarkNotPerformedCreateBodyNoteDefault = ``;

export const MaintenanceVisitPeriodsMarkNotPerformedCreateBody = zod.object({
  "carId": zod.string().uuid(),
  "periodStart": zod.string().date(),
  "note": zod.string().default(maintenanceVisitPeriodsMarkNotPerformedCreateBodyNoteDefault)
}).describe('Which period a write applies to. The pair is the period\'s identity.')

export const MaintenanceVisitPeriodsMarkNotPerformedCreateResponse = zod.object({
  "id": zod.string(),
  "carId": zod.string().uuid(),
  "carName": zod.string(),
  "propertyId": zod.string().uuid().nullable(),
  "propertyName": zod.string(),
  "serviceProviderName": zod.string(),
  "periodStart": zod.string().date(),
  "periodEnd": zod.string().date(),
  "periodMonths": zod.number(),
  "requiredQuantity": zod.number(),
  "requiredUnit": zod.enum(['visits', 'hours']).describe('\* `visits` - Visits\n\* `hours` - Hours'),
  "achievedQuantity": zod.number(),
  "hoursDerived": zod.boolean().describe('Every ticket behind this figure had its hours inferred from start and finish because no on-site time was reported, so the total can include travel and breaks. A period with a mix is not flagged here; the tickets carry it individually. Never true for a contract measured in visits.'),
  "coverage": zod.enum(['complete', 'partial', 'none']).describe('\* `complete` - Requirement met\n\* `partial` - Short of the requirement\n\* `none` - No records'),
  "resolution": zod.enum(['unresolved', 'not_performed']).describe('\* `unresolved` - Nobody has said\n\* `not_performed` - The rest never happened'),
  "isOpen": zod.boolean(),
  "clippedStart": zod.boolean(),
  "clippedEnd": zod.boolean(),
  "outcome": zod.enum(['done', 'partial', 'missing', 'skipped', 'open']).describe('\* `done` - Requirement met\n\* `partial` - Part of the work reached us\n\* `missing` - No record reached us\n\* `skipped` - Skipped visit\n\* `open` - Period still running'),
  "contested": zod.boolean(),
  "tickets": zod.array(zod.object({
  "id": zod.string().uuid(),
  "number": zod.string(),
  "visitedOn": zod.string().date(),
  "hours": zod.number(),
  "hoursDerived": zod.boolean().describe('This ticket reported no on-site time, so its hours are the gap between start and finish.')
}).strict().describe('A maintenance ticket we hold for the period, enough to name it and link to it.')),
  "history": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.enum(['marked_not_performed', 'removed_not_performed', 'record_received']).describe('\* `marked_not_performed` - Marked as not performed\n\* `removed_not_performed` - Not performed removed\n\* `record_received` - Maintenance record received'),
  "at": zod.string().datetime({"offset":true}),
  "actor": zod.string(),
  "note": zod.string()
}).strict().describe('One entry in a period\'s timeline.'))
}).strict().describe('One cadence period on one elevator, as `build_visit_periods` derives it.')

/**
 * One row per elevator instead of one per period.
 */
export const MaintenanceVisitPeriodsSummaryRetrieveQueryParams = zod.object({
  "car": zod.string().uuid().optional().describe('One elevator.'),
  "car_limit": zod.number().optional().describe('Return at most this many elevators. Defaults to all of them.'),
  "car_offset": zod.number().optional().describe('Skip this many elevators, in name order.'),
  "contract": zod.string().uuid().optional().describe('Every elevator on one contract, across its properties.'),
  "end_date": zod.string().date().optional().describe('Defaults to the last day of the current month.'),
  "property": zod.string().uuid().optional().describe('Every elevator at one property.'),
  "start_date": zod.string().date().optional().describe('Defaults to the first of the month eleven months back.')
})

export const MaintenanceVisitPeriodsSummaryRetrieveResponse = zod.object({
  "window": zod.object({
  "startDate": zod.string().date(),
  "endDate": zod.string().date()
}).strict(),
  "cars": zod.array(zod.object({
  "carId": zod.string().uuid(),
  "carName": zod.string(),
  "propertyId": zod.string().uuid().nullable(),
  "propertyName": zod.string(),
  "serviceProviderName": zod.string(),
  "periodMonths": zod.number(),
  "requiredQuantity": zod.number(),
  "requiredUnit": zod.enum(['visits', 'hours']).describe('\* `visits` - Visits\n\* `hours` - Hours'),
  "periodCount": zod.number(),
  "done": zod.number(),
  "partial": zod.number(),
  "missing": zod.number(),
  "skipped": zod.number(),
  "open": zod.number(),
  "periods": zod.array(zod.object({
  "periodStart": zod.string().date(),
  "periodEnd": zod.string().date(),
  "coverage": zod.enum(['complete', 'partial', 'none']).describe('\* `complete` - Requirement met\n\* `partial` - Short of the requirement\n\* `none` - No records'),
  "resolution": zod.enum(['unresolved', 'not_performed']).describe('\* `unresolved` - Nobody has said\n\* `not_performed` - The rest never happened'),
  "achievedQuantity": zod.number(),
  "hoursDerived": zod.boolean(),
  "isOpen": zod.boolean(),
  "clippedStart": zod.boolean(),
  "clippedEnd": zod.boolean(),
  "outcome": zod.enum(['done', 'partial', 'missing', 'skipped', 'open']).describe('\* `done` - Requirement met\n\* `partial` - Part of the work reached us\n\* `missing` - No record reached us\n\* `skipped` - Skipped visit\n\* `open` - Period still running')
}).strict().describe('One cell of the grid: which period, and what we can say about it.'))
}).strict().describe('One elevator\'s tally, for scopes too large to send every period.')),
  "totalCars": zod.number().describe('Elevators in scope across every page.')
}).strict().describe('One row per elevator, with the window the caller should draw them in.')

